import {
    apiRequest,
    ManajemenTalentaMatrix,
    ManajemenTalentaMatrixSearch,
    GetEselon,
    GetPosition,
    GetMxEmpLists,
    JpmSearch
} from "../../../../../services/adapters/Laporan/manajemenTalentaService"
import {AcManajerialPeriod} from "../../../../../services/adapters/Assesment/assesmentService";

class IndexRepository {

    fetchMatrix = async (query) => {
        return await apiRequest("get", ManajemenTalentaMatrix, {
            params: query
        }, true)
    }
    fetchSearch = async (query) => {
        return await apiRequest("get", ManajemenTalentaMatrixSearch, {
            params: query
        }, true)
    }
    fetchPeriod = async (query) => {
        return await apiRequest("get", AcManajerialPeriod, {
            params: query
        }, true)
    }
    fetchEselon = async (query) => {
        return await apiRequest("get", GetEselon, {
            params: query
        }, true)
    }
    fetchMatrixassesmentlist = async (query) => {
        return await apiRequest("get", GetMxEmpLists, {
            params: query
        }, true)
    }
    fetchSearchJpm = async (query) => {
        return await apiRequest("get", JpmSearch, {
            params: query
        }, true)
    }
    fetchPosition = async (query) => {
        return await apiRequest("get", GetPosition, {
            params: query
        }, true)
    }
}

export default IndexRepository